/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Checkout_Support_Reasons1Inputs */

const vi_sitesettings_checkout_support_reasons1 = /** @type {(inputs: Sitesettings_Checkout_Support_Reasons1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do liên hệ hỗ trợ đơn`)
};

/**

* @param {Sitesettings_Checkout_Support_Reasons1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_checkout_support_reasons1 = /** @type {((inputs?: Sitesettings_Checkout_Support_Reasons1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Checkout_Support_Reasons1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_checkout_support_reasons1(inputs)
});
export { sitesettings_checkout_support_reasons1 as "siteSettings_checkout_support_reasons" }